import { PRESET_CARD_ACTIONS_GAP, PRESET_CARD_CLASS, PRESET_GRID_CLASS } from 'modules/manager/ui/components/preset-card-metrics';
import React from 'react';

interface GroupCardSkeletonProps {
  canWrite?: boolean;
  canDuplicate?: boolean;
}

export const TemplateGroupCardSkeleton: React.FC<GroupCardSkeletonProps> = ({ canWrite = false, canDuplicate = false }) => {
  const iconsCount = (canDuplicate ? 1 : 0) + (canWrite ? 2 : 0);

  return (
    <div className={PRESET_CARD_CLASS} data-testid="template-group-card-skeleton">
      <div className="flex min-h-[88px] min-w-0 flex-col justify-between">
        <div className="skeleton-block h-3 w-3/5" />
        <div className="flex flex-col gap-2">
          <div className="skeleton-block h-3 w-2/5" />
          <div className="skeleton-block h-3 w-1/3" />
        </div>
      </div>
      <div className="flex items-center justify-between">
        <div className="skeleton-block h-9 w-[91px]" />
        <div className="flex items-center" style={{ gap: PRESET_CARD_ACTIONS_GAP }}>
          {Array.from({ length: iconsCount }, (_, index) => (
            <div key={index} className="skeleton-block size-5" />
          ))}
        </div>
      </div>
    </div>
  );
};

interface GroupGridSkeletonProps extends GroupCardSkeletonProps {
  count?: number;
}

export const TemplateGroupGridSkeleton: React.FC<GroupGridSkeletonProps> = ({ count = 8, ...cardProps }) => (
  <div className={PRESET_GRID_CLASS} data-testid="template-group-grid-skeleton" aria-hidden>
    {Array.from({ length: count }, (_, index) => (
      <TemplateGroupCardSkeleton key={index} {...cardProps} />
    ))}
  </div>
);
